import { useTranslation } from "react-i18next";
import LanguageSwitcherComponent from "../../../../components/language-switcher/language-switcher.component";
import "./home-intro.component.scss";

const HomeIntroComponent = () => {
  const { t } = useTranslation();
  return (
    // <div>
    //   <LanguageSwitcherComponent />
    //   <div className="home-intro-container bg-img-cover text-3xl flex justify-start items-end pb-8">
    //     <div className="circle-title flex flex-col items-center justify-center bg-[#4c2e6b] rounded-full p-4 text-white md:ml-32">
    //       <div className="welcome-font title mb-2">Transdev</div>
    //       <div className="logo-font title">Learn2Prompt</div>
    //     </div>
    //     <div className="slogan-font bg-white p-2 w-fit circle-title flex items-center justify-center rounded-full">{t("tagline")}</div>
    //   </div>
    // </div>
    <div>
    <LanguageSwitcherComponent />
    <div className="home-intro-container bg-img-cover justify-start text-3xl">
      <div className="text-white" style={{ paddingTop: '80px', paddingLeft: '60px' }}>
        {/* <div className="welcome-font title">Transdev</div> */}
        <div className="logo-font title">Learn2Prompt</div>
        <div className="slogan-font p-2 w-fit">{t("tagline")}</div>
      </div>
    </div>
  </div>
  );
};

export default HomeIntroComponent;
